import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { StyledMachineRobotCleaningStatus } from './MachineRobotCleaningStatus.styles';
import { RobotUtils } from 'app/utils/robot/RobotUtils';
import {
  MachineConnectionStatus,
  RobotStatus,
} from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { Optional } from 'lib/types/Optional';

export const MachineRobotCleaningStatus = ({
  robotStatus,
  connectionStatus,
  isPaused = false,
}: {
  robotStatus: Optional<RobotStatus>;
  connectionStatus: MachineConnectionStatus;
  /** Paused is reported by the API separately from the headline status, which stays Autonomous. */
  isPaused?: boolean;
}): JSX.Element => {
  const { t } = useTranslation();
  const baseDisplayName = RobotUtils.getRobotStatusDisplayName(robotStatus, connectionStatus);
  const robotStatusDisplayName = isPaused && baseDisplayName === 'Cleaning' ? 'Paused' : baseDisplayName;
  const className = classnames(
    robotStatusDisplayName.toLowerCase().concat('-status'),
    'machine-robot-cleaning-status__data'
  );
  return (
    <StyledMachineRobotCleaningStatus title={t(`robotDashboard.${robotStatusDisplayName}`)} className={className}>
      <span className="machine-robot-cleaning-status__dot" />
      <span className="machine-robot-cleaning-status__label">{t(`robotDashboard.${robotStatusDisplayName}`)}</span>
    </StyledMachineRobotCleaningStatus>
  );
};
